import { cn } from '@/lib/utils'

interface Props {
  value: 'immigration' | 'eoir' | null
  onChange: (value: 'immigration' | 'eoir') => void
}

export const CaseViewTabs: React.FC<Props> = ({ value, onChange }) => {
  return (
    <div className={cn('flex', 'gap-5')}>
      <Trigger
        title="Immigration Cases"
        selected={value === 'immigration'}
        disabled={!value}
        onChange={() => onChange('immigration')}
      />
      <Trigger
        title="EOIR Cases"
        selected={value === 'eoir'}
        disabled={!value}
        onChange={() => onChange('eoir')}
      />
    </div>
  )
}

interface TriggerProps {
  title: string
  selected: boolean
  disabled: boolean
  onChange: () => void
}

const Trigger: React.FC<TriggerProps> = (props) => {
  return (
    <button
      className={cn(
        'pb-1',
        'text-[18px] font-semibold leading-[28px]',
        {
          'text-foreground': props.selected,
          'text-slate-300': !props.selected,
        },
        'duration-120 transition-all',
        'border-b-2 border-b-transparent',
        {
          'border-b-foreground': props.selected,
        }
      )}
      disabled={props.disabled}
      onClick={props.onChange}
    >
      {props.title}
    </button>
  )
}
